export const FilterOption = {
  STARTS_WITH: 1,
  ENDS_WITH: 2,
  CONTAINS: 3,
  NOT_CONTAIN: 4,
  EMPTY: 5,
  NOT_EMPTY: 6,
  GREATER: 7,
  GREATER_OR_EQUAL: 8,
  LESS: 9,
  LESS_OR_EQUAL: 10,
  EQUAL: 11,
  NOT_EQUAL: 12,
};

export type Param = {
  value?: string;
  name: string;
  option?: number;
  isEmpty?: boolean;
};

export const getParams = (params: Param[]) => {
  return (
    params
      .filter(({ value, isEmpty }) => isEmpty || Boolean(value))
      .map(({ value, name, option = FilterOption.CONTAINS }, index) => {
        return (
          `FilterParams[${index}].ColumnName=${name}` +
          `&FilterParams[${index}].FilterOption=${option}` +
          (value ? `&FilterParams[${index}].filterValue=${value}` : '')
        );
      })
      .join('&') || ''
  );
};
